// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/js/bootstrap.min.js'
// import 'bootstrap/css/bootstrap.min.css'
import '../src/comm/css/normalize.css'
import '../src/comm/css/style.css'
import '../src/comm/css/font-awesome.min.css'
import '../src/comm/js/bootstrapValidator.min.js'
import '../src/comm/css/bootstrapValidator.min.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import config from '../static/config'
Vue.prototype.$config = config
// import '../src/comm/js/delighters.min.js'

import axios from 'axios'

window.axios = axios;

import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue);

Vue.config.productionTip = false

axios.defaults.baseURL = Vue.prototype.$config.$baseUrl; //正式环境
axios.interceptors.response.use(data => {
    return data.data;
});
axios.interceptors.request.use(
    config => {
        let token = sessionStorage.getItem("token") || "";
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
      /* 这句非常重要，否则预渲染将不会启动 */ 
      mounted () {
        document.dispatchEvent(new Event('render-event')) 
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js